+function($, document) {
	var scope;
	
	var InviteModal = function(element, options) {
		scope = this;
		
		this.$element = $(element);
		this.options = options;
		this.$body = $(document.body);
		
		this.initialize();
	};
	
	InviteModal.DEFAULTS = {
		clipboardMoviePath: null,
		copyTextSelector: '.text-copied',
		tagsInputWidth: 400,
		tagsInputHeight: 150
	};
	
	InviteModal.prototype.initialize = function() {
		this.elCopyText = $(this.options.copyTextSelector);
		this.elInviteForm = this.$element.find('.invite-form');
		this.elInviteSuccess = this.$element.find('.invite-success');
		this.elEmail = this.$element.find('.email input');
		
		this.initModal();
		this.initCopyLink();
		this.initSendButton();
		
		this.initTags();
	};
	
	InviteModal.prototype.initModal = function() {
		this.$element.on('shown.bs.modal', function() {
			scope.restore();
		});
		
		this.$body.on('click', function(e) {
			var target = $(e.target);
			
			if ( ! target.is('[data-toggle="center-modal"]') && target.parents('.modal-invite').length == 0) {
				scope.$element.modal('hide');
			}
		});
	};
	
	InviteModal.prototype.initCopyLink = function() {
		$(function() {
			var copyBtn = scope.$element.find('.referrer button'),
				clientTarget = new ZeroClipboard(copyBtn, {
				    moviePath: scope.options.clipboardMoviePath,
				    debug: false
				});

			clientTarget.on( "load", function(clientTarget)
			{
			    clientTarget.on( "complete", function(clientTarget, args) {
			        clientTarget.setText(args.text);
			    });
			});
		});
		
		this.$element.on('click', '.referrer button', function(event) {
			event.preventDefault();
			
			scope.elCopyText.show();
			
			setTimeout(function() {
				scope.elCopyText.hide();
			}, 3000);
		});
	};
	
	InviteModal.prototype.initTags = function() {
		this.elEmail.tagsInput({
		   'height': scope.options.tagsInputHeight + 'px',
		   'width': scope.options.tagsInputWidth + 'px',
		   'interactive': true,
		   'defaultText': 'Add email',
		   'removeWithBackspace' : true,
		   'placeholderColor' : '#666666'
		});
	};
	
	InviteModal.prototype.restore = function() {
		scope.elInviteForm.show();
		scope.elInviteSuccess.hide();
	};
	
	InviteModal.prototype.initSendButton = function() {
		this.$element.on('click', '.email button', function(event) {
			event.preventDefault();
			
			var deffered,
				buttonEl = $(this),
				emailEl = buttonEl.parents('.email').find('input'),
				email = emailEl.val(),
				validate = true,
				emails = [];
			
			if ( ! email) {
				alert('Error: Email is required');
				
				return false;
			}
			
			//vlidate emails
			if (email.indexOf(',') != -1) {
				emails = email.split(',');
			}else {
				emails.push(email);
			}
			
			$.each(emails, function(index, email) {
				if ( ! validateEmail(email)) {
					validate = false;
					
					return false;
				}
			});
			
			if ( ! validate) {
				alert('Error: include invalid email address');
				
				return false;
			}
			
			//now send the email
			$.publish('showajaxmask.sn');
			deffered = $.post('/customer/invite', {emails: emails});
			
			deffered.done(function(res) {
				if (res.success) {
					scope.elInviteForm.hide();
					scope.elInviteSuccess.show();
				}else {
					alert(res.feedback);
				}
			});
			
			deffered.always(function() {
				$.publish('hideajaxmask.sn');
			});
			
			return false;
		});
	};
	
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.inviteModal'),
			options = $.extend({}, InviteModal.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.inviteModal', (data = new InviteModal(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}

	$.fn.inviteModal = Plugin;
	$.fn.inviteModal.Constructor = InviteModal;
	
	//data-api
	$(function() {
		$('[data-toggle="invite-modal"]').each(function () {
			var $element = $(this);
		  
			Plugin.call($element, $element.data())
		});
	})
}(jQuery, document);